import { toast } from 'react-toastify';

import { AnyAction } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';

import * as Constants from '../constants';
import {IReferentials, IResponseReferential} from '../reducers';
import * as Services from '../services';

export function* getReferentials(_action: AnyAction) {
  try {
    const payload: IReferentials = yield call(Services.getReferentials);

    yield put({
      type: Constants.GET_REFERENTIALS_SUCCESS,
      payload
    });
  } catch (error) {
    yield put({ type: Constants.GET_REFERENTIALS_FAILED, error });
    toast.error(error.message);
  }
}

export const teamSagas = [takeLatest(Constants.GET_REFERENTIALS, getReferentials)];
